import './styles/index.css';
import { WirespanApp } from './app';
import { must } from './ui/dom';
import { toast } from './ui/toast';
import { registerServiceWorker } from './pwa';

const board = must<SVGSVGElement>('board');
const app = new WirespanApp(board);

void app.start().catch((err: unknown) => {
  console.error('Wirespan failed to start', err);
  toast('The grid failed to start. Try reloading.');
});

registerServiceWorker();
